import { IGetAllBancoPagamentoWithFiltersUseCase } from "../../../presentation/useCases/read/get_all_banco_pagamento_with_filters_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { BancoPagamento } from "../../models/banco_pagamento";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetAllBancoPagamentoWithFiltersUseCase
 */

export class GetAllBancoPagamentoWithFiltersUseCase
  extends BasePaginatedUseCase<BancoPagamento>
  implements IGetAllBancoPagamentoWithFiltersUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }
  async getAllBancoPagamentoWithFilters(
    idsBancoPagamento: number[],
    status: number,
    currentPage: number,
    rowsPerPage: number): Promise<void> {

    const result = await this.repository.getAllBancoPagamentoWithFilters(
      idsBancoPagamento,
      status,
      currentPage,
      rowsPerPage
    )

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }
}
